/**
 * Created by maofaming on 2017/4/27.
 */
export default {
    mounted () {
        this.isScrollFixed = false;
        this.isScrollDefault = false;
        this.fixedNode = this.$el.querySelector('.el-table__header-wrapper');
        this.fixedBodyNode = this.$el.querySelector('.el-table__body-wrapper');
        this.topBannerHeight = 49;
        if (this.fixedNode) {
            let viewRect = this.fixedNode.getBoundingClientRect();
            this.scrollTopPosition = viewRect.top - this.topBannerHeight;
            document.addEventListener('scroll', this.scrollEvent);
        }
    },
    beforeDestroy () {
        this.isScrollFixed = false;
        this.isScrollDefault = false;
        this.fixedNode = null;
        document.removeEventListener('scroll', this.scrollEvent);
    },
    methods: {
        scrollEvent (event) {
            let scrollNode = document.scrollingElement || document.body;
            let top = scrollNode ? scrollNode.scrollTop : 0;
            if (top >= this.scrollTopPosition) {
                this.isScrollDefault = false;
                let width;
                if (this.fixedNode.currentStyle) {
                    width = this.fixedNode.currentStyle.width;
                } else {
                    width = window.getComputedStyle(this.fixedNode, null).width;
                }

                if (!this.isScrollFixed) {
                    this.fixedNode.style.cssText =
                        'position: fixed;' +
                        'bottom: -10px; ' +
                        'width:' +
                        width +
                        ';height: 50px;' +
                        'top: ' +
                        this.topBannerHeight +
                        'px; ' +
                        'z-index:1;';
                    this.isScrollFixed = true;
                }
            } else {
                this.isScrollFixed = false;
                if (!this.isScrollDefault) {
                    this.fixedNode.style.cssText = '';
                    this.isScrollDefault = true;
                }
            }
        }
    }
};
